import { render, staticRenderFns } from "./StudentAccount.vue?vue&type=template&id=2e721604"
import script from "./StudentAccount.vue?vue&type=script&lang=js"
export * from "./StudentAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports